import { render, staticRenderFns } from "./FullScreenDialog.vue?vue&type=template&id=0fa2e998&scoped=true"
import script from "./FullScreenDialog.vue?vue&type=script&lang=js"
export * from "./FullScreenDialog.vue?vue&type=script&lang=js"
import style0 from "./FullScreenDialog.vue?vue&type=style&index=0&id=0fa2e998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa2e998",
  null
  
)

export default component.exports